import Vue from 'vue';

import { VueMaskDirective } from "v-mask";

// as directive
export default Vue.directive('mask', VueMaskDirective);